import DegitalBook from '../../views/history/DegitalBook.vue';
import DegitalBookBlock from '../../views/history/DegitalBookBlock.vue';

// 閲覧履歴一覧表示画面
window.Vue.component('degital-book', DegitalBook);
window.Vue.component('degital-book-block', DegitalBookBlock);
